import {Component, input, model} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from '../../../../shared/shared.module';
import {CegidExportErrorDTO} from '../../../../core/dtos/facturation/fournisseurs/cegid/cegid-export-error-dto';
import {CEGID_EXPORT_ERROR_MOTIF_LABELS} from '../../../../core/enums/facturation/fournisseur/cegid-export-error-motif-enum';

@Component({
  selector: 'yo-cegid-export-errors-dialog',
  templateUrl: './cegid-export-errors-dialog.component.html',
  styleUrls: ['./cegid-export-errors-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxDataGridModule, SharedModule]
})
export class CegidExportErrorsDialogComponent {

  readonly displayDialog = model<boolean>(false);
  readonly errorList = input<CegidExportErrorDTO[]>([]);

  getMotifLabel = (error: CegidExportErrorDTO): string => CEGID_EXPORT_ERROR_MOTIF_LABELS[error.motif] ?? error.motif;

  getTypeLabel = (error: CegidExportErrorDTO): string => error.type === 'FACTURE' ? 'Facture' : 'Avoir';

  closeDialog = (): void => this.displayDialog.set(false);
}
